import AlertConfirm from "./AlertConfirm"

export default AlertConfirm
